const enUS = {
  'login.title': 'Student Account Login',
  'login.description': '',
  'login.account_label': 'Student Account',
  'login.password_label': 'Password',
  'login.login_button': 'Login',
  'home.prologue_button': 'prologue',
  'home.epilogue_button': 'epilogue',
  'password.title': 'Successfully signed in!',
  'password.input_comment': 'Enter a password',
  'password.input_comment2': 'Use this password to login to your account',
  'password.input_caution1': '※The password needs to be between 8~12 characters',
  'password.input_caution2': '※Choose a different password from your initial password',
  'password.input_caution3': '※Please be sure to keep your password in a safe place',
  'password.password_label': 'Password',
  'password.password_confirm_label': 'Confirm Password',
  'password.register_button': 'Register',
  'password.message.password': 'Enter a password',
  'password.message.password.format': 'The password needs to be between 8~12 characters',
  'password.message.password.default': 'Choose a different password from your initial password',
  'password.message.password_confirm.format': 'Confirm password should be same as password',
  'profile.title': 'player information',
  'profile.nickname_label': 'nickname',
  'profile.register_button': 'register',
  'profile.cancel_button': 'cancel',
  'profile.message.nickname': 'Input your nickname',
  'profile.message.avatar_file_name': 'Select an avatar',
  'saga.login_error_message': 'Unable to sign into your account',
  'saga.player_setting_error_message': 'Unable to retrieve student information',
  'saga.chapter_list_error_message': 'Unable to retrieve chapter list',
  'saga.put_player_error_message': 'Unable to save student information',
  'saga.player_logout_message': 'Logged Out',
};
export default enUS;
